import TrustpilotIcon from '@assets/svg/icons/trustpilot.svg'
import { withDisplayName } from '@hocs/with-display-name'
import { ReviewCard } from '@ui/review-card'
import { graphql } from 'gatsby'
import React from 'react'

const TrustpilotReviewCard: Utils.EntryFC<
  Queries.TrustpilotReviewCardFragment
> = ({
  content: {
    text,
    title,
    consumer: { displayName },
    stars,
    createdAt,
  },
  entryInspectorProps,
}) => (
  <ReviewCard
    content={text}
    displayName={displayName}
    Icon={TrustpilotIcon}
    publishedDate={createdAt}
    rate={stars}
    title={title}
    {...entryInspectorProps()}
  />
)

export const query = graphql`
  fragment TrustpilotReviewCard on TrustpilotReview {
    ...TrustpilotReview
    text
    title
    consumer {
      displayName
    }
    stars
    createdAt(formatString: "DD-MM-YYYY")
  }
`

export default withDisplayName(TrustpilotReviewCard, 'TrustpilotReviewCard')
